import { render } from "./IndexSearchInput.vue?vue&type=template&id=44adefe7"
import script from "./IndexSearchInput.vue?vue&type=script&lang=js"
export * from "./IndexSearchInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IndexSearchInput.vue"]])

export default __exports__